module.exports = __webpack_public_path__ + "static/media/active-minutes-video.07fabaab.mp4";